export default function HowItWorks() {
  const steps = [
    {
      step: '01',
      title: 'Discover Categories',
      desc: 'Browse through organized product categories using the dropdown menu or category cards to find exactly what interests you.',
      icon: 'ri-compass-3-line',
    },
    {
      step: '02',
      title: 'Review Product Information',
      desc: 'Explore curated collections with key product details, organized in an easy-to-scan format so you can evaluate options quickly.',
      icon: 'ri-file-list-3-line',
    },
    {
      step: '03',
      title: 'Compare Options',
      desc: 'Use the structured layout to compare products side by side, helping you identify the best choices for your needs and budget.',
      icon: 'ri-scales-line',
    },
    {
      step: '04',
      title: 'Visit Main Website',
      desc: 'Once you have found what you are looking for, follow the link to the main website to complete your exploration and shopping journey.',
      icon: 'ri-external-link-line',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-4">
          How VigorBuy Spreadsheet Works
        </h2>
        <p className="text-center text-foreground-500 text-sm md:text-base mb-12 max-w-2xl mx-auto">
          Four simple steps to transform your product discovery experience
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {steps.map((item, idx) => (
            <div key={idx} className="relative text-center group">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-500 text-2xl`}></i>
              </div>
              <span className="inline-block text-xs font-bold text-primary-400 bg-primary-100 px-2.5 py-0.5 rounded-full mb-3">
                Step {item.step}
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>

              {idx < 3 && (
                <div className="hidden lg:block absolute top-8 -right-3 text-primary-300">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}